import classNames from "classnames";
import React, { ComponentProps } from "react";

import "./text-area-with-count.css";

type TextAreaWithCountProps = {
	ref?: React.Ref<HTMLTextAreaElement>;
} & ComponentProps<"textarea">;

export const TextAreaWithCount = ({
	className,
	maxLength,
	ref,
	value,
	...props
}: TextAreaWithCountProps) => {
	const textValue = typeof value === "string" ? value : String(value ?? "");
	const count = textValue.replace(/\n|\r|\r\n|\s/g, "").length;
	const shouldShowCount = !!maxLength;

	return (
		<div className="text-area-with-count">
			<textarea className={classNames(className)} ref={ref} value={value} {...props} />
			{shouldShowCount && (
				<div className="text-area-with-count__count">
					{count}/{maxLength}
				</div>
			)}
		</div>
	);
};
TextAreaWithCount.displayName = "TextAreaWithCount";
